import {useBoatsClassesApi} from "../../api/boatsClasses";
import {useCallback, useEffect, useRef, useState} from "react";

export const useBoatLabels = () => {
    const [boats, setBoats] = useState([]);
    const boatsApi = useBoatsClassesApi();

    useEffect(() => {
        if (boats.length) return;

        boatsApi.getEntries()
            .then(data => {
                setBoats(data);
            })
            .catch(console.error);
    }, [boatsApi]);

    const getBoatLabel = useCallback((boatClass) => {
        if (!boatClass) return '';
        return boats.find(boat => boat.class === boatClass)?.label || boatClass;
    }, [boats]);

    return { getBoatLabel };
};